import { initializeApp, getApps } from "firebase/app";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";
import { authClient } from "@/lib/auth";
import { toast } from "sonner";

const cfg = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

let inited = false;

// Register for web push after login. Silent no-op if unsupported / denied / unconfigured.
export async function initPush(user) {
  if (!user || inited) return;
  if (!cfg.apiKey || !process.env.REACT_APP_FCM_VAPID_KEY) return;
  try {
    if (!(await isSupported())) return;
    if (typeof Notification === "undefined" || Notification.permission === "denied") return;
    if (Notification.permission === "default") {
      const perm = await Notification.requestPermission();
      if (perm !== "granted") return;
    }
    const app = getApps().length ? getApps()[0] : initializeApp(cfg);
    const messaging = getMessaging(app);
    const reg = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
    const token = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FCM_VAPID_KEY,
      serviceWorkerRegistration: reg,
    });
    if (token) {
      await authClient.post("/push/register", { token });
      inited = true;
    }
    onMessage(messaging, (payload) => {
      const n = payload?.notification || {};
      if (n.title) toast(n.title, { description: n.body });
    });
  } catch (e) {
    // silent — push is best-effort
  }
}
